import { graphql } from '__generated__';

import { useQueryStable } from '../useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetSlowestModels = graphql(/* GraphQL */ `
  query MostSlowestModels($environmentId: BigInt!, $start: Date!, $end: Date!) {
    performance(environmentId: $environmentId) {
      longestExecutedModels(start: $start, end: $end) {
        maxExecutionTime
        uniqueId
        isDeleted
        byJob {
          jobId
          maxExecutionTime
        }
      }
    }
  }
`);

type SlowestModelsParams = {
  environmentId?: number;
  startDate: string;
  endDate: string;
  limit: number;
  pause?: boolean;
};

export const useSlowestModels = ({
  environmentId = 0,
  startDate = '2023-08-01',
  endDate = '2023-09-27',
  limit = 5,
  pause,
}: SlowestModelsParams) => {
  const query = useQueryStable({
    query: GetSlowestModels,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      limit,
    },
    pause: pause || !environmentId || !startDate || !endDate || !limit,
  });

  // TODO: we need a cache invalidation strategy for performance endpoints

  return query;
};
